import React, { createContext, useContext, useEffect, useState } from "react";
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import { auth } from "../firebase"; // from your firebase.js

const AuthContext = createContext();

// This is the provider we'll import in index.js
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Monitor Firebase auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    // Clean up subscription on unmount
    return unsubscribe;
  }, []);

  // Auth functions
  function signUp(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function signIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logOut() {
    return signOut(auth);
  }

  // The value prop of the provider will be our context data
  const value = {
    currentUser,
    signUp,
    signIn,
    logOut,
  };

  return (
    <AuthContext.Provider value={value}>
      {/* 
        If we're still loading the user state, you might 
        want to return a spinner or something 
      */}
      {!loading && children}
    </AuthContext.Provider>
  );
}

// Helper hook to access the auth context
export function useAuth() {
  return useContext(AuthContext);
}